import type { MapNode } from './jsx';

// Lazy registry keyed by map "theme" / key (matches FieldTheme + extended MapKey).
// Each entry imports a `.map.tsx` module whose default export is the JSX root.
// All 17 maps from /maps/ + maps.json are represented here.
export const MAP_REGISTRY: Record<string, () => Promise<{ default: MapNode }>> = {
  // Field maps (procedural ground + optional layered props)
  lorencia:           () => import('./Lorencia.map'),
  lorencia_outskirt:  () => import('./LorenciaOutskirt.map'),
  noria:              () => import('./Noria.map'),
  devias:             () => import('./Devias.map'),
  dungeon:            () => import('./Dungeon.map'),
  atlans:             () => import('./Atlans.map'),
  tarkan:             () => import('./Tarkan.map'),
  icarus:             () => import('./Icarus.map'),
  kalima:             () => import('./Kalima.map'),
  crywolf:            () => import('./Crywolf.map'),
  swamp_of_calmness:  () => import('./SwampOfCalmness.map'),
  // Event / dungeon maps
  blood_castle:       () => import('./BloodCastle.map'),
  devil_square:       () => import('./DevilSquare.map'),
  chaos_castle:       () => import('./ChaosCastle.map'),
  illusion_temple:    () => import('./IllusionTemple.map'),
  castle_siege:       () => import('./CastleSiege.map'),
  golden_invasion:    () => import('./GoldenInvasion.map'),
  hero_dungeon:       () => import('./HeroDungeon.map'),
};

export function hasMapModule(key: string): boolean {
  return key in MAP_REGISTRY;
}

export async function loadMapModule(key: string): Promise<MapNode | null> {
  const loader = MAP_REGISTRY[key];
  if (!loader) return null;
  const mod = await loader();
  return mod.default;
}
